import { ReactNode } from "react";
import cn from "clsx";

export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Rechts ausgerichteter Aktions-Slot (Buttons etc.). */
  actions?: ReactNode;
  className?: string;
}

/** Einheitlicher Seiten-Einstieg (Spec §3). */
export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex items-start justify-between gap-4 flex-wrap",
        className
      )}
    >
      <div className="min-w-0">
        <h1 className="font-display text-2xl font-semibold tracking-tight text-text">
          {title}
        </h1>
        {description && (
          <p className="mt-1 text-sm text-text-2">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}

export default PageHeader;
